export default {
  userNotFound: "ERROR_USER_NOT_FOUND",
  invalidToken: "ERROR_INVALID_TOKEN",
  noToken: "ERROR_NO_TOKEN",
  accountTypeForbidden: "ERROR_ACCOUNTTYPE_FORBIDDEN",
  userDataMissing: "ERROR_USERDATA_MISSING"
};
